export default function descending(a, b) {
  return a == null || b == null ? NaN
    : b < a ? -1
    : b > a ? 1
    : b >= a ? 0
    : NaN;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/descending.js
// module id = 153
// module chunks = 0